// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/decelerometer-crfi-reading.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/decelerometer-crfi-reading/decelerometer-crfi-reading.js';

mount([g0]);
